<template>
  <div id="app" class="flex justify-center items-center h-screen">
    <div id="iframe-container" class="absolute top-0 left-0 w-full h-full">
      <iframe id="my-iframe" :src="iframeSrc" class="w-full h-full border-none"></iframe>
    </div>
    <div id="overlay" v-show="show" class="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-10"></div>
    <div id="popup" v-show="show" class="popup-container relative rounded-2xl text-center">
      <div class="custom-bg"></div>

      <MissingDeposit 
        v-if="currentScreen === 6"
        :todayTotal="todayTotal"
        :iframeSrc="iframeSrc"
        @notifications-disabled="handleNotificationsDisabled" />

      <!-- Only show PushNotification in PWA mode or if user explicitly wants notifications -->
      <!-- <PushNotification
        v-if="(isPWA || isDireto) && currentScreen === 0 && !notificationsGranted"
        @notifications-enabled="handleNotificationsEnabled"
        @notifications-disabled="handleNotificationsDisabled"
      /> -->
      <PushNotification
        v-if="isPWA && currentScreen === 0 && !notificationsGranted"
        @notifications-enabled="handleNotificationsEnabled"
        @notifications-disabled="handleNotificationsDisabled"
      />

      <ScreenOne 
        v-if="currentScreen === 1" 
        :referral="referral"
        @update-today-total="updateTodayTotal"
        @missing-deposit="showMissingDeposit"
        @next-screen="showScreen2" />

      <ScreenTwo 
        v-if="currentScreen === 2" 
        @next-screen="showScreen3" />

      <ScreenThree
        v-if="currentScreen === 3"
        :selectedGame="selectedGame"
        :checked1="checked1"
        :checked2="checked2"
        :checked3="checked3"
        :isActive="isActive"
        @previous-screen="showScreen2"
        @next-screen="showScreen4"
        @update-checked="updateChecked" />

      <ScreenFour 
        v-if="currentScreen === 4" 
        :selectedGame="selectedGame" 
        @modification-complete="handleModificationComplete" />

      <!-- AddToHomeScreen only shows when explicitly requested -->
      <AddToHomeScreen
        v-if="currentScreen === 5" 
        :deferredPrompt="deferredPrompt" 
        @start-process="handleInstallApp"
        @cancel-process="handleCancelInstall" />
    </div>

    <!-- Optional install button for browser users -->
    <!-- <div v-if="!isPWA && deferredPrompt && !show" class="fixed bottom-4 right-4 z-20">
      <button @click="showAddToHomeScreen" class="install-button bg-blue-600 text-white px-4 py-2 rounded-lg shadow-lg">
        📱 Instalar App
      </button>
    </div> -->

    <FloatingNotification
      v-if="showFloatingNotification"
      :selectedGame="selectedGame"
      :isActive="isActive"
      :notificationsEnabled="notificationsEnabled"
      @notification-click="handleNotificationClick"
      @update-checked="updateChecked"
      @toggle-notifications="handleToggleNotifications" />

    <ScreenSettings
      v-if="showSettings && selectedGame"
      :selectedGame="selectedGame"
      :checked1="checked1"
      :checked2="checked2"
      :checked3="checked3"
      :isActive="isActive"
      @close-settings="closeSettings"
      @expand-game="expandGame"
      @save-settings="saveSettings"
      @update-checked="updateChecked" />
  </div>
</template>

<script>
import ScreenOne from './components/ScreenOne.vue';
import ScreenTwo from './components/ScreenTwo.vue';
import ScreenThree from './components/ScreenThree.vue';
import ScreenFour from './components/ScreenFour.vue';
import FloatingNotification from './components/FloatingNotification.vue';
import ScreenSettings from './components/ScreenSettings.vue';
import AddToHomeScreen from './components/AddToHomeScreen.vue';
import PushNotification from './components/PushNotification.vue';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { messaging, getToken } from './firebaseConfig.js';
import MissingDeposit from './components/MissingDeposit.vue';
import api from './services/api';
import { criarAtribuicao } from './services/atribuicaoVisitante';
import { ORIGEM_MODOHACK, assinarWebPushNaPagina, chavePublicaVapid } from './services/webPush';

export default {
  name: 'App',
  components: {
    ScreenOne,
    ScreenTwo,
    ScreenThree,
    ScreenFour,
    FloatingNotification,
    ScreenSettings,
    AddToHomeScreen,
    PushNotification,
    MissingDeposit,
  },
  data() {
    return {
      show: false,
      currentScreen: 0, // Inicia em 0 para mostrar PushNotification se estiver em PWA
      selectedGame: null,
      showFloatingNotification: false,
      iframeSrc: 'https://hypez.bet/',
      showSettings: false,
      checked1: false,
      checked2: false,
      checked3: false,
      isActive: true,
      deferredPrompt: null,
      isPWA: window.matchMedia('(display-mode: standalone)').matches,
      isDireto: (new URL(window.location.href)).pathname.includes('/dr'),
      isIOS: /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
      isChrome: /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor),
      notificationsGranted: false,
      notificationsEnabled: true,
      visitorId: 'foo',
      todayTotal: 0,
      referral: '',
    };
  },
  methods: {
    handleInstallApp() {
      // User chose to install - close the popup and let them continue in browser
      this.show = false;
      document.getElementById('iframe-container').classList.remove('blur');
    },
    handleToggleNotifications(enabled) {
      if (enabled) {
        // Verificar se ainda tem permissão do navegador
        if (Notification.permission === 'granted') {
          this.notificationsEnabled = true;
          this.notificationsGranted = true;
          localStorage.setItem('notificationsEnabled', 'true');
          this.updateFCMToken(); // Garante que o token está atualizado
          console.log('Notificações ativadas');
        } else {
          // Sempre solicitar permissão quando usuário tenta ativar
          // Mesmo se foi negada antes (pode ter mudado nas configurações)
          this.requestNotificationPermission();
        }
      } else {
        // Usuário desativou as notificações
        this.notificationsEnabled = false;
        localStorage.setItem('notificationsEnabled', 'false');
        console.log('Notificações desativadas');
      }
    },
    
    async requestNotificationPermission() {
      try {
        const permission = await Notification.requestPermission();
        if (permission === 'granted') {
          this.notificationsGranted = true;
          this.notificationsEnabled = true;
          localStorage.setItem('notificationsEnabled', 'true');
          this.updateFCMToken();
          console.log('Permissão de notificação concedida');
        } else {
          this.notificationsEnabled = false;
          this.notificationsGranted = false;
          localStorage.setItem('notificationsEnabled', 'false');
          console.log('Permissão de notificação negada');
        }
      } catch (error) {
        console.error('Erro ao solicitar permissão de notificação:', error);
        this.notificationsEnabled = false;
        this.notificationsGranted = false;
      }
    },
    handleCancelInstall() {
      // User chose not to install - continue with browser version
      this.show = false;
      this.currentScreen = 1;
      document.getElementById('iframe-container').classList.remove('blur');
    },
    updateTodayTotal(value) {
      this.todayTotal = value;
    },
    closePopup() {
      this.show = false;
    },
    showScreen2() {
      this.currentScreen = 2;
      this.iframeSrc = 'https://hypez.bet/';
    },
    showScreen3(selectedGame) {
      this.selectedGame = selectedGame;
      this.iframeSrc = selectedGame.iframe_src;
      this.currentScreen = 3;
    },
    expandGame(selectedGame) {
      this.showScreen3(selectedGame);
      this.show = true;
      this.showFloatingNotification = false;
      this.showSettings = false;
    },
    showScreen4() {
      this.currentScreen = 4;
    },
    handleModificationComplete() {
      this.showFloatingNotification = true;
      this.show = false;
      document.getElementById('iframe-container').classList.remove('blur');
    },
    handleNotificationClick() {
      this.showFloatingNotification = false;
      this.showSettings = 3;
      this.show = false;
      document.getElementById('iframe-container').classList.add('blur');
    },
    closeSettings() {
      this.showSettings = false;
      this.showFloatingNotification = true;
      document.getElementById('iframe-container').classList.remove('blur');
    },
    saveSettings() {
      this.showSettings = false;
      this.showFloatingNotification = true;
      document.getElementById('iframe-container').classList.remove('blur');
    },
    updateChecked(values) {
      this.checked1 = values.checked1;
      this.checked2 = values.checked2;
      this.checked3 = values.checked3;
      this.isActive = values.isActive;
    },
    // Dual-run da F4 (plano-firebase-para-aws.md:2.2): a assinatura Web Push
    // VAPID e' feita no MESMO ponto do registro FCM, com o MESMO visitorId --
    // e' por esse device_id que o backend sabe que o aparelho ja tem o canal
    // novo e para de mandar pelo FCM. Sem VUE_APP_WEBPUSH_PUBLIC_KEY no build,
    // nada acontece. Nao ha novo pedido de permissao: quem chega aqui ja tem.
    assinarWebPushVapid() {
      // Sai antes do FingerprintJS: com a flag desligada o boot tem que ficar
      // exatamente como era, sem trabalho novo nenhum.
      if (!chavePublicaVapid()) {
        return;
      }
      FingerprintJS.load()
        .then((fp) => fp.get())
        .then((result) => {
          this.visitorId = result.visitorId;
          return assinarWebPushNaPagina({
            origem: ORIGEM_MODOHACK, deviceId: result.visitorId, http: api,
          });
        })
        .catch((error) => {
          console.warn(JSON.stringify({ evento: 'webpush_visitorid_falhou', erro: String(error) }));
        });
    },
    updateFCMToken() {
      // Independente do getToken: se o FCM falhar, o canal VAPID ainda assina.
      this.assinarWebPushVapid();
      getToken(messaging, { vapidKey: 'BBXU8VejhyacmsVb_eUe-iN9r-2LbBP5quvO8zH2kcJ9828VYsMGLVczvJgeEvW0LiZ3yV0Kleh9TpEG3hUpSrk' })
      .then((currentToken) => {
        if (currentToken) {
          console.log('Token retrieved: ', currentToken);
          // api 
          FingerprintJS.load().then(fp => {
            fp.get().then(result => {
              this.visitorId = result.visitorId;
              api.post('notification/api/fcm-token/', {
                token: currentToken,
                device_id: this.visitorId
              }).then((response) => {
                  console.log('Token saved to database', response);
              }).catch((error) => {
                console.error('Error saving token to database:', error);
              });
            });
          });
        } else {
          console.log('No registration token available. Request permission to generate one.');
        }
      }).catch((err) => {
        console.log('An error occurred while retrieving token. ', err);
      });
    },
    // Atribuicao de afiliado fora do RTDB (plano-firebase-para-aws.md:2.1):
    // services/atribuicaoVisitante.js decide por VUE_APP_ATRIBUICAO.
    async getQueryStringFromDb(visitorId){
      // `checkPWAStatus` roda antes do FingerprintJS resolver, entao `visitorId`
      // ainda pode ser o placeholder; sem ele a chamada so geraria 404 na API.
      if (!visitorId || visitorId === 'foo') {
        return;
      }
      try {
        const atribuicao = await criarAtribuicao();
        const queryString = await atribuicao.ler(visitorId);
        if (queryString) {
          this.iframeSrc += queryString;
        }
      } catch (error) {
        console.error('Error reading query string from database:', error);
      }
    },
    checkPWAStatus() {
      // const url = ;
      console.log('this.isDireto', this.isDireto)
      if (this.isPWA) {
        console.log('Running as PWA');
        // force to get token on PWA
        this.updateFCMToken();
        // Recupera a query string do Realtime Database
        this.getQueryStringFromDb(this.visitorId);

        // No PWA, sempre vai direto para a tela 1
        this.currentScreen = 1;
      } else {
        console.log('Not running as PWA');
        console.log('Running in browser - proceeding without installation');
        this.currentScreen = 1;
        // if(!this.isDireto){
        //   this.showAddToHomeScreen();
        // }else{
        //   console.log('Running as Direto');
        //   if(this.isIOS){
        //     console.log('Running as IOS');
        //     this.currentScreen = 1;
        //   }else{
        //     if (this.isChrome) {
        //       console.log('Running as Chrome');
        //       this.currentScreen = 0;
        //     } else {
        //       console.log('Not running as Chrome');
        //       this.currentScreen = 1;
        //     }
        //   }
        // }
      }
    },
    checkNotificationPermission() {
      try {
        const savedPreference = localStorage.getItem('notificationsEnabled');
        
        if (Notification.permission === 'granted') {
          this.notificationsGranted = true;
          // Se o usuário tinha ativado e ainda tem permissão, manter ativo
          if (savedPreference === 'true') {
            this.notificationsEnabled = true;
            this.updateFCMToken(); // Garante que o token está atualizado
          } else {
            this.notificationsEnabled = false;
          }
          if (this.isPWA) {
            this.currentScreen = 1; // Pula direto para a tela 1
          }
        } else {
          this.notificationsGranted = false;
          // Se a permissão foi revogada, forçar desativar mesmo se estava ativo no localStorage
          this.notificationsEnabled = false;
          localStorage.setItem('notificationsEnabled', 'false');
          
          // Se está em PWA, não força a tela de notificação
          // O usuário pode ativar pelo toggle depois
          if (this.isPWA) {
            this.currentScreen = 1; // Vai direto para a tela 1
          }
        }
      } catch (e) {
        console.log('Error checking notification permission:', e);
        this.notificationsEnabled = false;
        this.notificationsGranted = false;
      }
    },
    showAddToHomeScreen() {
      // Make this optional - only show if explicitly requested
      this.currentScreen = 5;
      this.show = true;
      document.getElementById('iframe-container').classList.add('blur');
    },
    handleNotificationsEnabled() {
      this.notificationsGranted = true;
      this.notificationsEnabled = true;
      localStorage.setItem('notificationsEnabled', 'true');
      this.currentScreen = 1;
    },
    handleNotificationsDisabled() {
      this.notificationsEnabled = false;
      localStorage.setItem('notificationsEnabled', 'false');
      this.currentScreen = 1;
    },
    showMissingDeposit() {
      this.currentScreen = 6;
      this.show = true;
      document.getElementById('iframe-container').classList.add('blur');
    },
    setReferral(queryString) {
      // get ref= from the URL else none
      this.referral = new URLSearchParams(queryString).get('c');
    },
    saveQueryStringToDatabase(queryString) {
      FingerprintJS.load().then(fp => {
        fp.get().then(async result => {
          this.visitorId = result.visitorId;
          try {
            const atribuicao = await criarAtribuicao();
            await atribuicao.gravar(result.visitorId, queryString);
            console.log('Query string saved to database');
          } catch (error) {
            console.error('Error saving query string to database:', error);
          }
        });
      });
    },
  },
  mounted() {

    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      this.deferredPrompt = e;
    });

    // if PWA or not we need to get the query string from the database
    FingerprintJS.load().then(fp => {
      fp.get().then(async result => {
        this.visitorId = result.visitorId;
        const atribuicao = await criarAtribuicao();
        const queryString = await atribuicao.ler(this.visitorId);
        if (queryString) {
          this.setReferral(queryString);
          this.saveQueryStringToDatabase(queryString);
          this.iframeSrc += queryString;
        }
      }).catch((error) => {
        console.error('Error reading query string from database:', error);
      });
    });

    // when is not PWA we need to check if there is a query string in the URL and save it to the database
    const queryString = window.location.search;
    if (queryString) {
      this.setReferral(queryString);
      this.saveQueryStringToDatabase(queryString);
    }


    setTimeout(() => {
      this.show = true;
      document.getElementById('iframe-container').classList.add('blur');
    }, 500);

    this.checkPWAStatus();
    this.checkNotificationPermission();

  }
};
</script>

<style>
html, body {
  background-color: #0f1923;
}
#app {
  display: flex;
  justify-content: center;
  align-items: center;
}
#iframe-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.custom-bg {
  background-color: #130A1E6E;
  border: 1px solid #5D477970;
  border-radius: 10px;
  opacity: 0.94;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}
.close-button {
  position: absolute;
  top: 0.5rem;
  right: 1rem;
  background: none;
  border: none;
  color: #4e4879;
  font-size: 1.5rem;
  cursor: pointer;
}
.popup-container {
  max-width: 400px;
  width: 95%;
  z-index: 10;
  position: relative;
}

/* CSS para o botão de instalação opcional */
.install-button {
  transition: all 0.3s ease;
  font-size: 14px;
  font-weight: 600;
}

.install-button:hover {
  background-color: #1e40af;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
</style>
